import React, { useEffect, useState } from 'react';
import useStyles from './styles';
import Paper from '@mui/material/Paper';
import ChevronUp from 'mdi-material-ui/ChevronUp';

const ScrollToTop = ({ visibleYOffset }: ScrollToTopProps) => {
  const { classes } = useStyles();

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > visibleYOffset);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [visibleYOffset]);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    visible && (
      <Paper
        elevation={3}
        square
        classes={{
          root: classes.paper,
        }}
        onClick={handleClick}
      >
        <ChevronUp className={classes.chevron} fontSize="large" />
      </Paper>
    )
  );
};

export type ScrollToTopProps = {
  visibleYOffset: number;
};

export default ScrollToTop;
